'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var modules_5e1660a2 = {"container":"Divider_module_container__88c99553","size-2":"Divider_module_size2__88c99553","size-4":"Divider_module_size4__88c99553","size-8":"Divider_module_size8__88c99553","size-12":"Divider_module_size12__88c99553","size-16":"Divider_module_size16__88c99553","size-20":"Divider_module_size20__88c99553","size-24":"Divider_module_size24__88c99553","size-28":"Divider_module_size28__88c99553","size-32":"Divider_module_size32__88c99553","size-36":"Divider_module_size36__88c99553","size-40":"Divider_module_size40__88c99553"};
require("../../../assets/cjs/components/Divider/src/Divider~5LcqzRiO.css");

exports.default = modules_5e1660a2;
//# sourceMappingURL=Divider.module.less.js.map
